module.exports = __webpack_public_path__ + "media/stylesheets/images/recruit/yokokawa-1-b586e1cfa884b08b98583045cbeef413.jpg";